
import { Component, Vue, Watch } from 'vue-property-decorator';
import timestatistical from "./components/timestatistical.vue"
import lineCharts from "./components/line-charts.vue"
import column2Charts from "./components/column2-charts.vue"
import breadCharts from "./components/bread-charts.vue"
import Dialog from '@/components/dialog.vue';
import {
	getSearchDate,
	nextDay
} from "@/utils"
import {
	transactionOvervieworderMoneyDistribution,
	transactionOverviewtradeCustomer,
	transactionOverviewtradeScene,
	transactionOverviewtradeOverview,
	transactionOverviewtradeOverviewList
} from "@/api/material"
import { imgHost } from '@/utils/config';
@Component({
	name: '',
	components: {
		timestatistical,
		lineCharts,
		column2Charts,
		breadCharts,
		'slz-dialog': Dialog,
	}
})

export default class ProductList extends Vue {
	private explainShow = false
	private scenarioShow = false
	private up = 'http://cdn2024.shiwuzone.com/routuan/image/dataAnalysis-up.png'
	private down = 'http://cdn2024.shiwuzone.com/routuan/image/dataAnalysis-down.png'
	private tradingloading = false
	private constituteloading = false
	private type1 = 1;
	private time1: any = []
	private type2 = 1;
	private time2: any = []
	private linedata: any = []
	private columndata: any = []
	private moneyloading = false
	private lines: any = []
	private customerloading = false
	private customerlist: any = []
	private compare = [
		{ type: 1, label: '较前一日' },
		{ type: 2, label: '较前一周' },
		{ type: 3, label: '较前一月' },
		{ type: 4, label: '较前7天' },
		{ type: 5, label: '较前30天' },
	]
	private scenarioloading = false
	private scenariolist: any = []
	private datamsg: any = {}
	private lineloading = false
	private lines1: any = []

	private isToday = true;
	private time2IsToday = true;

	@Watch('type1')
	private type1Change(newd, oldd) {
		this.checkIsToday();
	}
	@Watch('time1')
	private time1Change(newd, oldd) {
		this.checkIsToday();
	}

	@Watch('type2')
	private type2Change(newd, oldd) {
		this.checkTime2IsToday();
	}
	@Watch('time2')
	private time2Change(newd, oldd) {
		this.checkTime2IsToday();
	}


	private mounted() {
		this.time1 = getSearchDate(2)
		this.time2 = getSearchDate(2)
		this.getnumdata()
		this.getlinecharts()
		this.getmoneysurvey()
		this.getcustomersurvey()
		this.getscenariosurvey()
	}

	private checkIsToday(){
		if (this.type1 === 1){
			let dt = new Date();
			let year = dt.getFullYear();
			let month = dt.getMonth();
			let day = dt.getDate();

			if (new Date(year, month, day).getTime() === new Date(this.time1[0].split('-').join('/')).getTime()){
				this.isToday = true;
			}else{
				this.isToday = false;
			}
		}else{
			this.isToday = false;
		}
	}
	private checkTime2IsToday(){
		if (this.type2 === 1){
			let dt = new Date();
			let year = dt.getFullYear();
			let month = dt.getMonth();
			let day = dt.getDate();

			if (new Date(year, month, day).getTime() === new Date(this.time2[0].split('-').join('/')).getTime()){
				this.time2IsToday = true;
			}else{
				this.time2IsToday = false;
			}
		}else{
			this.time2IsToday = false;
		}
	}

	private gettime(e, num) {
		let type = 'type' + num
		let time = 'time' + num
		this[type] = e.type
		this[time] = e.time
		if (num == 1) {
			this.getnumdata()
			this.getlinecharts()
		} else if (num == 2) {
			this.getmoneysurvey()
			this.getcustomersurvey()
			this.getscenariosurvey()
		}
	}
	private noinus(num: number) {
		if (num < 0) {
			let str = num + ''
			return str.substring(1, str.length)
		}
		return num || 0
	}
	//交易概况
	private async getnumdata() {
		try {
			this.tradingloading = true
			let data = {
				TimeType: this.type1,
				StartDate: this.time1[0],
				EndDate: this.time1[1]
			}
			let res = await transactionOverviewtradeOverview(data)
			if (res.IsSuccess) {
				this.datamsg = res.Result
			}
		} finally {
			this.tradingloading = false
		}
	}
	//交易概况 折线图
	private async getlinecharts() {
		try {
			this.lineloading = true
			//linedata
			let data = {
				TimeType: this.type1,
				StartDate: this.time1[0],
				EndDate: this.time1[1]
			}
			let res = await transactionOverviewtradeOverviewList(data)
			if (res.IsSuccess) {
				this.linedata = res.Result.map(v => {
					v.Date = v.StatisEndDate
					return v
				})
				this.lines1 = [
					{ key: 'SubmitOrderMemberCount', name: '下单人数', defaultshow: true },
					{ key: 'SubmitOrderCount', name: '订单数量', defaultshow: true },
					{ key: 'SubmitOrderMoney', name: '下单金额', defaultshow: false },
					{ key: 'MallUV', name: '访客数', defaultshow: false },
				]
			}
		} finally {
			this.lineloading = false
		}
	}
	//订单金额分布图
	private async getmoneysurvey() {
		try {
			this.moneyloading = true
			let data = {
				TimeType: this.type2,
				StartDate: this.time2[0],
				EndDate: this.time2[1]
			}
			let res = await transactionOvervieworderMoneyDistribution(data)
			if (res.IsSuccess) {
				this.columndata = res.Result
				// console.log(this.columndata)
				this.lines = [
					{ key: 'OrderCount', name: '订单数量' }
				]
			}
		} finally {
			this.moneyloading = false
		}
	}
	//成交客户构成
	private async getcustomersurvey() {
		try {
			this.customerloading = true
			let data = {
				TimeType: this.type2,
				StartDate: this.time2[0],
				EndDate: this.time2[1]
			}
			let res = await transactionOverviewtradeCustomer(data)
			if (res.IsSuccess) {
				this.customerlist = res.Result.map(v => {
					v.name = v.CustomerTypeDisplay
					v.value = v.SubmitOrderMemberCount
					v.label = v.CustomerTypeDisplay
					return v
				})
			}
		} finally {
			this.customerloading = false
		}
	}
	//成交场景分析
	private async getscenariosurvey() {
		try {
			this.scenarioloading = true
			let data = {
				TimeType: this.type2,
				StartDate: this.time2[0],
				EndDate: this.time2[1]
			}
			let res = await transactionOverviewtradeScene(data)
			if (res.IsSuccess) {
				this.scenariolist = res.Result.map(v => {
					v.name = v.TradeSceneTypeDisplay
					v.value = v.SubmitOrderMemberCount
					v.label = v.TradeSceneTypeDisplay
					return v
				})
			}
		} finally {
			this.scenarioloading = false
		}
	}
}
